/**
 * ダッシュボード画面用コンポーネント
 * 
 * @returns 
 */
export default function DashboardPage(): JSX.Element {

	// 描画する
	return (
		<br />
	);

}